import React from 'react';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper,
  Labels
} from 'containers';

import { HeaderText } from 'components';
import { ConfirmButton, CancelButton } from 'components/buttons';

const SettingsConfirmation = ({
  onConfirm,
  onCancel,
  content
}) => {
  const buttonConfig = {
    left: {
      onClick: () => onConfirm(true)
    },
    right: {
      onClick: () => onCancel(false)
    }
  };

  return [
    <Display key="display">
      <Header>
        <HeaderText value={content.title} />
      </Header>
      <Content>
        <Labels values={content.data} />
      </Content>
      <Footer>
        <ConfirmButton />
        <CancelButton />
      </Footer>
    </Display>,
    <HardwareButtonWrapper key="buttons" config={buttonConfig} />
  ];
};

export default SettingsConfirmation;



// WEBPACK FOOTER //
// ./src/screens/shared/Settings/SettingsConfirmation/SettingsConfirmation.js